module.exports = __webpack_public_path__ + "img/kehu1.9f2c122c.png";